import { useState } from 'react';

import { isStorageAvailable } from '../common/utils/isStorageAvailable';

export default function useSessionStorage(
  key: string,
  initialValue: string = '',
): [string, (value: string) => void] {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item || initialValue;
    } catch (error) {
      if (isStorageAvailable()) {
        console.warn(error);
      }
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to sessionStorage.
  const setValue = (value: unknown) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      window.sessionStorage.setItem(key, valueToStore);
    } catch (error) {
      // A more advanced implementation would handle the error case
      // Output the error only if the sessionStorage is accessible.
      if (isStorageAvailable()) {
        console.warn(error);
      }
    }
  };
  return [storedValue, setValue];
}
